import React, { Fragment, FunctionComponent } from 'react';
import "../error.scss"
import Text from '../../../components/typography/typgraphy';

const InactiveAccountError: FunctionComponent = () => {
  return (
    <Fragment>
      <Text className="error-description">Looks like your Axis account needs to be reactivated.</Text>
      <Text className="error-description">Please submit a request form at your nearest branch to reactivate your account.</Text>
      <Text className="error-description">Resume your outward remittance journey post updation.</Text>
    </Fragment>
  )
}

export default InactiveAccountError;
